import { mapCollection } from '../../utils/collection.utils';
import { PendingOrderType } from '../pending-order-type';

export class PendingOrderTypesBuilder {

  static fromJson(json) {
    return (json)
      ? new PendingOrderType(
        json.code,
        json.translate,
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(PendingOrderTypesBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/pending-order-type.builder.ts